<template>
  <div class="upload system-upload-file">
    <el-upload
      v-if="!uploading"
      :ref="'upload_'+ type"
      action="#"
      :auto-upload="false"
      :accept="acceptType"
      :limit="limitNum"
      :on-change="handleFile.bind(this,type)"
      :on-remove="handleRemove.bind(this,type)"
      :on-exceed="handleFileExceed.bind(this,type)"
      :file-list="fileList"
    >
      <el-button
        size="small"
        plain
        type="primary"
      >  <svg-icon icon-class="upload-mark-default" />   {{ $t('tips.click_to_upload') }}</el-button>
    </el-upload>
    <div v-if="uploading" class="parse">
      Uploading
    </div>
    <Progress :progress="uploadingProgress" />
  </div>

</template>
<script>
// import { uploadFileShowProgress } from '@/api/components/upload'
import { uploadFileWithProgress } from '@/api/components/upload'
export default {
  name: 'UpdateFile',
  components: {
    Progress: () => import('@/views/components/Progress.vue')
  },
  props: {
    list: {
      type: Array,
      default: function() {
        return []
      }
    },
    limitNum: {
      type: Number,
      default: 1000
    },
    type: {
      type: [String, Number],
      default: ''
    },
    fileDir: {
      type: String,
      default: 'MERCHANT_RECHARGE'
    },
    acceptType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileList: [],
      removeFiles: [],
      uploadingProgress: 0,
      uploading: false
    }
  },
  methods: {
    handleFile(type, file, fileList) {
      if (this.uploading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }
      if (/\s/g.test(file.name)) {
        this.$message.warning('The file name cannot have spaces, please modify and upload!')
        this.removeUploadFile(type, file)
        return
      }
      if (this.list.length >= this.limitNum) {
        this.$message.warning(`Upload up to ${this.limitNum} files!`)
        this.removeUploadFile(type, file)
        return
      }

      const findItem = this.list.find(item => item.name === file.name)
      if (findItem) {
        this.$message.warning('The file with the same name cannot be uploaded, please upload again!')
        this.removeUploadFile(type, file)
        this.uploading = false
        this.uploadingProgress = 0
        return
      }
      this.uploading = true
      const params = {}
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('business', this.fileDir)
      params.data = formData
      // 上传进度，固定到大概95%，等后台响应成功显示100%
      params.onUploadProgress = (progressEvent) => {
        const value = Math.floor((progressEvent.loaded * 100) / (progressEvent.total * 1.05))
        this.uploadingProgress = value
      }

      uploadFileWithProgress(params).then(res => {
        if (this.removeFiles.includes(file.uid)) {
          return
        }
        const { path, ...otherData } = res.data
        this.$message.success('Uploaded Successfully')
        this.$emit('change')
        this.$emit('templateFileSuccess', { type, fileName: file.name, relativePath: path, ...otherData })
        this.fileList = []
        this.uploadingProgress = 100
        setTimeout(() => {
          this.uploadingProgress = 0
        }, 500)
      }).catch((err) => {
        // 上传失败，文件还是会显示，要移除文件
        this.removeUploadFile(type, file)
        console.error('err', err)
      }).finally(() => {
        this.uploading = false
        this.uploadingProgress = 0
      })
    },
    removeUploadFile(type = '', file) {
      const uid = file.uid
      if (!this.$refs['upload_' + type]) {
        return
      }
      const idx = this.$refs['upload_' + type].uploadFiles.findIndex(item => item.uid === uid)
      if (idx !== -1) {
        this.$refs['upload_' + type].uploadFiles.splice(idx, 1)
      }
    },
    handleRemove(type, file, fileList) {
      this.fileList = fileList
      if (file.status === 'ready') {
        this.uploadingProgress = 0
        this.uploading = false
        this.removeFiles.push(file.uid)
      }
    },
    handleFileExceed(type) {
      if (this.fileList[type].length >= this.limitNum) {
        this.$message.warning(`The current limit is ${this.limitNum}, please delete and upload again!`)
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload{
  display: inline-block;
}
.btn-update{
  margin-left: 10px;
}
.upload-container{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    cursor: pointer;
    line-height: 100px;
    vertical-align: top;
    font-size: 12px;
    color: #8c939d;
    .icon-add{
      font-size: 8px;
    }
}
.parse{
    width: 100%;
    min-width: 300px;
    margin-top: 20px;
    font-size: 14px;
    color: #606266;
}
</style>
